export default __webpack_public_path__ + "static/media/AmandaBaroni_01.3a2ab5a2.jpg";